import { cva } from 'class-variance-authority'

export const messageVariants = cva(
  'w-full text-sm rounded-lg border-none p-3 flex space-x-2 items-start',
  {
    variants: {
      variant: {
        info: 'bg-blue-50 dark:bg-blue-950 text-blue-600 dark:text-blue-300 fill-blue-600 dark:fill-blue-300',
        warning:
          'bg-orange-50 dark:bg-orange-950 text-orange-600 dark:text-orange-400 fill-orange-600 dark:fill-orange-400',
        success:
          'bg-green-50 dark:bg-green-950 text-green-600 dark:text-green-300 fill-green-600 dark:fill-green-300',
        danger:
          'bg-red-50 dark:bg-red-950 text-red-600 dark:text-red-300 fill-red-600 dark:fill-red-300',
        neutral: 'bg-gray-100 dark:bg-gray-800 text-secondary',
      },
    },
    defaultVariants: {
      variant: 'info',
    },
  },
)
